import React from 'react';
import moment from 'moment';
import { DatePicker, notification, Radio } from 'antd';
import Cron, { HEADER } from '../../../localNodeModules/customCronGenerator';
import GenericSearchModalNew from '../tableHelperComponents/GenericSearchModalNew';
import "../../../styles/stylesheets/Breadcrumb/ExportExcel.scss"
import IconsPath from "../../../assets/icons/index";
import dayjs from 'dayjs';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { displayNamesForNewSubmitApi } from '../tableHelperComponents/DisplayNameForNewServer';
import { CONFIG } from '../../../config';
import { getPermissionKey } from '../../../helper/permissions';
import UseDatePickerLocale from '../../input/LocaleInputDatePicker';
import GenericInput from '../../input/GenericInputComponent';
import GenericCustomButton from '../../GenericCustomButton';
import GenericDeleteModal from '../../helperComponents/GenericDeleteModal';
import { TriangleAlert } from 'lucide-react';
import NoDataFound from '../../NoDataFound';
const { RangePicker } = DatePicker;

let SITE_FILTER = {
    key: "email",
    entity: "supplymint.users",
    code: "username",
    value: ""
}
class EmailScheduler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // Loader, success modal and error modal
            loading: false,
            error: "",
            errorCode: "",
            errorMessage: "",
            successMessage: "",

            // Other 
            manageSchedule: false,
            scheduler: false,

            toEmail: "",
            toEmailArray: [],
            emailToErr: false,
            emailStr: "",
            ccEmail: [],
            fromDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
            dateRange: "SM_DATE_LAST7DAYS_VALUE",
            lineItemHeaders: {},
            hasAttachment: true,
            isAllData: "false",
            filterCondition: true,

            schedulerName: "",
            // cronExpression: "0 00 09 * ? * *",

            errors: {
                toEmail: "",
                schedulerName: "",
                fromDate: false,
                toDate: false
            },

            getDataSuccess: false,
            getDataError: false,
            emailSchedules: [],
            hoursValid:true,
            toEmailsObj: {},
            ccEmailsObj: {},
            headersMap: this.props.mainHeadersData[this.props.mainHeadersType],
            level: "headerLevel",
            headersType: this.props.mainHeadersType,
            selectedItems: this.props.mainHeadersData[this.props.mainHeadersType],
            inputData: {
                scheduleType: "once",
                days: []
            },
            selectedModal : "",
            selectedData : null,
            editSchedule : false,
            showAll: {toMail : false, ccMail : false}
        }
        this.updatedLocale = UseDatePickerLocale();
    }

    componentDidMount() {
        if(this.props.headerLevelModule === "VIEW_INDENTS") {
            this.props.handleApiChange("getHeadersRequest", {
                enterpriseName: "TURNINGCLOUD",
                displayName: "PI_EXCEL_HEADER",
                basedOn: "main"
            })
        }
        else if(this.props.headerLevelModule === "VIEW_ORDERS") {
            this.props.handleApiChange("getHeadersRequest", {
                enterpriseName: "TURNINGCLOUD",
                displayName: "PO_EXCEL_HEADER",
                basedOn: "main"
            })
        }
        document.addEventListener("keydown", this.closeOnEsc);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.closeOnEsc);
    }

    closeOnEsc = e => {
        if(e.key === "Escape") {
            this.props.close();
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.generalStore.getHeadersData.isSuccess) {
            // nextProps.getHeadersClear();
            return {
                loading: false,
                lineItemHeaders: nextProps.generalStore.getHeadersData.data?.resource?.["Default Headers"]?.lineItemHeaders
            };
        }
        else if (nextProps.generalStore.getHeadersData.isError) {
            // nextProps.getHeadersClear();
            return {
                loading: false,
                error: nextProps.generalStore.getHeadersData.message.status,
                errorCode: nextProps.generalStore.getHeadersData.message.error == undefined ? undefined : nextProps.generalStore.getHeadersData?.message?.error?.errorCode,
                errorMessage: nextProps.generalStore.getHeadersData.message.error == undefined ? undefined : nextProps.generalStore.getHeadersData?.message?.error?.errorMessage
            };
        }

        if(nextProps.generalStore.getEmailSchedulesData?.isLoading) {
            return {
                loading: true,
                getDataSuccess: false,
                getDataError: false
            };
        }
        if (nextProps.generalStore.emailReportData?.isSuccess) {
            // nextProps.emailReportClear();
            return {
                loading: false,
            };
        }
        else if (nextProps.generalStore.emailReportData.isError) {
            // nextProps.emailReportClear();
            return {
                loading: false,
                error: nextProps.generalStore.emailReportData?.message?.status,
                errorCode: nextProps.generalStore.emailReportData?.message?.error == undefined ? undefined : nextProps.generalStore.emailReportData.message?.error?.errorCode,
                errorMessage: nextProps.generalStore.emailReportData?.message?.error == undefined ? undefined : nextProps.generalStore.emailReportData?.message?.error?.errorMessage
            };
        }

        if(nextProps.generalStore.getEmailSchedulesData?.isSuccess) {
            // nextProps.getEmailSchedulesClear();
            return {
                loading: false,
                emailSchedules: (nextProps.generalStore.getEmailSchedulesData?.data?.resource) || [],
                getDataSuccess: true
            };
        }
        else if(nextProps.generalStore.getEmailSchedulesData.isError) {
            // nextProps.getEmailSchedulesClear();
            return {
                loading: false,
                error: nextProps.generalStore.getEmailSchedulesData?.message?.status,
                errorCode: nextProps.generalStore.getEmailSchedulesData?.message?.error == undefined ? undefined : nextProps.generalStore.getEmailSchedulesData?.message?.error?.errorCode,
                errorMessage: nextProps.generalStore.getEmailSchedulesData?.message?.error == undefined ? undefined : nextProps.generalStore.getEmailSchedules?.message?.error?.errorMessage,
                getDataError: true
            };
        }

        if(nextProps.generalStore.createEmailSchedulesData.isSuccess) {
            // nextProps.createEmailSchedulesClear();
            return {
                loading: false,
            };
        }
        else if(nextProps.generalStore.createEmailSchedulesData.isError) {
            // nextProps.createEmailSchedulesClear();
            return {
                loading: false,
                error: nextProps.generalStore.createEmailSchedulesData.message && nextProps.generalStore.createEmailSchedulesData.message.data && nextProps.generalStore.createEmailSchedulesData.message.data.status ? nextProps.generalStore.createEmailSchedulesData.message.data.status : "",
                errorCode: nextProps.generalStore.createEmailSchedulesData.message && nextProps.generalStore.createEmailSchedulesData.message.data && nextProps.generalStore.createEmailSchedulesData.message.data.errorCode ? nextProps.generalStore.createEmailSchedulesData.message.data.errorCode : "",
                errorMessage: nextProps.generalStore.createEmailSchedulesData.message && nextProps.generalStore.createEmailSchedulesData.message.data && nextProps.generalStore.createEmailSchedulesData.message.data.error ? nextProps.generalStore.createEmailSchedulesData.message.data.error : "",
            };
        }

        if(nextProps.generalStore.deleteEmailSchedulesData.isSuccess) {
            // nextProps.deleteEmailSchedulesClear();
            return {
                loading: false,
                selectedModal:false,
                selectedData: null,
                successMessage: nextProps.generalStore.deleteEmailSchedulesData.data.message
            };
        }
        else if(nextProps.generalStore.deleteEmailSchedulesData.isError) {
            // nextProps.deleteEmailSchedulesClear();
            return {
                loading: false,
                error: nextProps.generalStore.deleteEmailSchedulesData?.message?.status,
                errorCode: nextProps.generalStore.deleteEmailSchedulesData?.message?.error == undefined ? undefined : nextProps.generalStore.deleteEmailSchedulesData?.message?.error.errorCode,
                errorMessage: nextProps.generalStore.deleteEmailSchedulesData?.message?.error == undefined ? undefined : nextProps.generalStore.deleteEmailSchedulesData?.message?.error.errorMessage
            };
        }

        if(nextProps.generalStore.emailReportData.isLoading || nextProps.generalStore.getEmailSchedulesData.isLoading || nextProps.generalStore.createEmailSchedulesData.isLoading || nextProps.generalStore.deleteEmailSchedulesData.isLoading || nextProps.generalStore.getHeadersData.isLoading) {
            return {
                loading: true
            };
        }

        return null;
    }

    componentDidUpdate() {
        // if(this.props.generalStore.emailReport.isSuccess) {
        //     this.props.close();
        // }

        if(this.props.generalStore.emailReportData.isSuccess || this.props.generalStore.createEmailSchedulesData.isSuccess) {
            this.props.close();
            this.clearData();
        }

        if(this.props.generalStore.deleteEmailSchedulesData.isSuccess) {
            this.props.handleApiChange("getEmailSchedulesRequest",{
                pageNo: 1,
                type: 1,
                search: "",
                filter: {},
                sortedBy: "",
                sortedIn: "",
                displayName : this.props.headerLevelModule,
            }, getPermissionKey("common", "commonFunctionality", "view"));
        }
    }

    closeModal = () => {
        this.setState({
            error: "",
            errorCode: "",
            errorMessage: "",
            successMessage: ""
        });
    }

    multipleToggle = type => e => {
        if(type === "manageSchedule" && !this.state.manageSchedule) {
            this.props.handleApiChange("getEmailSchedulesRequest",{
                pageNo: 1,
                type: 1,
                search: "",
                filter: {},
                sortedBy: "",
                sortedIn: "",
                displayName : this.props.headerLevelModule
            }, getPermissionKey("common", "commonFunctionality", "view"));
        }
        this.setState(prevState => ({
            [type]: !prevState[type],
            editSchedule : false,
            selectedData : null,
        }));
    }

    handleInput = (e, level) => {
        e.persist();
        this.setState(prevState => {
            if(e.target.type === "checkbox") {
                return {
                    [e.target.name]: e.target.checked,
                };
            }
            else if(e.target.name === "emailStr") {
                return {
                    [e.target.name]: e.target.value.trim()
                };
            } else if(e.target.type === "radio") {
                return {
                    level: level
                }
            }
            return {
                [e.target.name]: e.target.value
            };
        }, () => {
            this.state.errors[e.target.name] !== undefined && this.validateInput(e.target.name);
            this.setHeaders();
        });
    }

    handleDateInput = (date, dateStr) => {
        this.setState({
            fromDate: dateStr[0],
            toDate: dateStr[1]
        }, () => {
            this.validateInput("fromDate");
            this.validateInput("toDate");
        });
    }

    handleBlur = (listName , emailName) => {
        if(this.state[emailName]) {
            this.addEmail({
                key: "Enter"
            },listName,emailName);
        }
    }

    validateInput = field => {
        let err = false;
        switch(field) {
            case "toEmail": {
                if(!(this.state.toEmail == "" && this.state.toEmailArray.length > 0)){
                    if((this.state.toEmail == "" && this.state.toEmailArray.length == 0 ) || !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(this.state.toEmail)) {
                        err = true;
                    }
                }
                break;
            }
            default: {
                if(this.state[field] === "") {
                    err = true;
                }
            }
        }
        this.setState(prevState => ({
            errors: {
                ...prevState.errors,
                [field]: err
            }
        }));
        return err;
    }

    addEmail = (e,listName,emailName) => {
        if((e.key === "Enter" || e.key === " " || e.key === ",") && /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/.test(this.state[emailName])) {
            this.setState(prevState => {
                let ccEmail = [...prevState[listName]];
                if(!~ccEmail.indexOf(prevState[emailName])) {
                    ccEmail.push(prevState[emailName]);
                }
                return {
                    [listName] : ccEmail,
                    [emailName]: ""
                };
            });
        }
    }

    removeEmail =(item,listName) => e => {
        this.setState(prevState => {
            let ccEmail = [...prevState[listName]];
            ccEmail.splice(ccEmail.indexOf(item), 1);
            return {
                [listName] : ccEmail
            };
        });
    }

    setCronExp = cronExpression => {
        this.setState({
            cronExpression
        });
    }

    onSubmit = (listName,emailName) => {
        if(this.state[emailName]) {
            this.addEmail({key: "Enter"},listName,emailName);
        }

        //setTimeout is used to make sure that emailStr is converted to a tag before API call
        setTimeout(() => {
            if(this.state.scheduler) {
                let valid = true;
                Object.keys(this.state.errors).forEach(key => {
                    if(this.validateInput(key)) {
                        valid = false;
                    }
                });
                if (this.state.inputData.scheduleType === "weekly") {
                    if (this.state.inputData?.days?.length == 0 || !this.state.inputData.time) {
                        notification.error({
                            message: "An Error Occurred!",
                            description: "Please fill mandatory Fields",
                            placement: "bottomLeft",
                            duration: 3,
                            key: Date.now().toString()
                        });
                        return
                    }
                }
                if (this.state.inputData.scheduleType === "once") {
                    if (!this.state.inputData.oneTime || !this.state.inputData.time) {
                        notification.error({
                            message: "An Error Occurred!",
                            description: "Please fill mandatory Fields",
                            placement: "bottomLeft",
                            duration: 3,
                            key: Date.now().toString()
                        });
                        return
                    }
                }
                    let payload = {};

                    if(this.state.editSchedule){
                        payload = {
                            id: this.state.id,
                            schedulerName: this.state.schedulerName,
                            cronExpression: this.generateCron()
                                ?.split(',')
                                .filter(day => day.trim() !== 'SUN')
                                .join(','),
                            toEmail: this.state.toEmailArray.join(),
                            ccEmail: this.state.ccEmail.join(),
                        };
                    }else{
                        payload = {
                            status: 1,
                            schedulerName: this.state.schedulerName,
                            cronExpression:  this.generateCron()
                                ?.split(',')
                                .filter(day => day.trim() !== 'SUN')
                                .join(','),
                            toEmail: this.state.toEmailArray.join(),
                            ccEmail: this.state.ccEmail.join(),
                            hasAttachment: this.state.hasAttachment,
                            dataExportJson: {}
                        };
                        if(["VIEW_INDENTS", "VIEW_ORDERS"].includes(this.props.headerLevelModule)) {
                            payload.dataExportJson = {
                                mName: this.props.headerLevelModule,
                                isAllItemLevelData: "false",
                                isOnlyCurrentPage: "false",
                                exportDataNode: {
                                    fromDate: moment().format("YYYY-MM-DD"),
                                    toDate: moment().format("YYYY-MM-DD"),
                                    dateRange: this.state.dateRange,
                                    isMainHeader: this.state.isAllData === "false",
                                    search: this.state.filterCondition ? this.props.exportDataNode.search : "",
                                    filter: this.state.filterCondition ? this.props.exportDataNode.filter : "",
                                    // headers: this.state.isAllData === "false" ? this.props.headers : this.state.lineItemHeaders,
                                    headers: this.state.selectedItems
                                }
                            }
                        }
                        else {
                            payload.dataExportJson = {
                                mName: this.state.isAllData === "true" ? this.props.detailLevelModule : this.props.headerLevelModule,
                                isAllItemLevelData: this.state.isAllData,
                                isOnlyCurrentPage: "false",
                                exportDataNode: {
                                    type: this.state.filterCondition ? this.props.exportDataNode.type : 1,
                                    ...this.props.exportDataNode,
                                    headers: this.state.selectedItems
                                }
                            };
                        }
                    }

                    // let moduleName = this.state.isAllData === "true" ? this.props.detailLevelModule : this.props.headerLevelModule;
                    // if(moduleName?.split(',')?.some(item => displayNamesForNewSubmitApi?.[item])){
                    //     payload["apiUrl"] = '/admin/download/module/data/export';
                    //     payload["baseUrl"] = CONFIG.SM_BACKEND_BASE_URL;
                    // }

                    if(this.state.editSchedule){
                        payload["apiUrl"] = '/ars/plan/update/email/scheduler';
                        payload["baseUrl"] = undefined;
                    }

                    this.props.handleApiChange("createEmailSchedulesRequest",payload, getPermissionKey("common", "commonFunctionality", "view"));
                // }
            }
            else {
                let valid = true;
                Object.keys(this.state.errors).forEach(key => {
                    if(key !== "schedulerName" && this.validateInput(key)) {
                        valid = false;
                    }
                });
                if(valid) {
                    let payload;
                    if(["VIEW_INDENTS", "VIEW_ORDERS"].includes(this.props.headerLevelModule)) {
                        payload = {
                            module: this.props.headerLevelModule,
                            isAllData: "false",
                            isOnlyCurrentPage: "false",
                            data: {
                                toEmail: this.state.toEmail,
                                ccEmail: this.state.ccEmail.join(),
                                fromDate: this.state.fromDate,
                                toDate: this.state.toDate,
                                isMainHeader: this.state.isAllData === "false",
                                search: this.state.filterCondition ? this.props.exportDataNode.search : "",
                                filter: this.state.filterCondition ? this.props.exportDataNode.filter : "",
                                headers: this.state.selectedItems
                                // headers: this.state.isAllData === "false" ? this.props.headers : this.state.lineItemHeaders
                            }
                        };
                    }
                    else {
                        payload = {
                            module: this.state.level === "headerLevel" ? this.props.headerLevelModule : this.props.detailLevelModule,
                            // module: this.state.isAllData === "true" ? this.props.detailLevelModule : this.props.headerLevelModule,
                            // isAllData: this.state.isAllData,
                            isAllData: this.state.level === "headerLevel" ? "false" : "true",
                            isOnlyCurrentPage: "false",
                            data: {
                                toEmail: this.state.toEmailArray.join(),
                                ccEmail: this.state.ccEmail.join(),
                                type: this.state.filterCondition ? this.props.exportDataNode.type : 1,
                                ...this.props.exportDataNode,
                                headers: this.state.selectedItems
                            }
                        };
                        let moduleName = this.state.level === "headerLevel" ? this.props.headerLevelModule : this.props.detailLevelModule;
                        if(moduleName?.split(',')?.some(item => displayNamesForNewSubmitApi?.[item])){
                            payload["apiUrl"] = '/admin/download/module/data/export';
                            payload["baseUrl"] = CONFIG.SM_BACKEND_BASE_URL;
                        }

                    }
                    this.props.handleApiChange("emailReportRequest",payload, getPermissionKey("common", "commonFunctionality", "view"));
                }
            }
        }, 0);
    }

    clearData = () => {
        this.setState({
            toEmail: "",
            emailToErr: false,
            emailStr: "",
            editSchedule : "",
            selectedData : null,
            ccEmail: [],
            hasAttachment: true,
            isAllData: "false",
            filterCondition: true,

            schedulerName: "",
            cronExpression: "0 0 09 1/1 * ? *",
            
            toEmailsObj: {},
            ccEmailsObj: {},

            errors: {
                toEmail: "",
                schedulerName: ""
            }
        });
    }

    isFilterApplied = data => {
        let parsedData;
        try {
            parsedData = JSON.parse(data);
            if(parsedData.exportDataNode.type == 1) {
                return false;
            }
            return true;
        }
        catch(e) {
            console.log(e);
            return false;
        }
    }

    editSchedule = item => e => {
        let updatedInputData = {...this.state.inputData};
        if(item?.cron_expression){
            updatedInputData = this.parseCron(item?.cron_expression);
            this.setState({
                inputData : updatedInputData,
            })
        }
        this.setState({
            manageSchedule: false,
            scheduler: true,
            id: item.id,
            schedulerName: item.scheduler_name || "",
            cronExpression: item?.cron_expression || "",
            toEmail : item?.to_email || "",
            toEmailArray: item.to_email ? item?.to_email?.split(",") : [],
            ccEmail: item.cc_email ? item.cc_email.split(",") : [],
            editSchedule : true,
            hasAttachment: item.has_attachment == "true" ? true : false,
            toEmailsObj : item.to_email  ?  {
                email : item.to_email ? item?.to_email?.split(",") : [],
            } : {},
            ccEmailsObj : item.cc_email ? {
                email : item.cc_email ? item?.cc_email?.split(",") : [],
            } : {},
            selectedData : item,
        });
    }

    // disableSchedule = item => e => {
    //     let dataExportJson = JSON.parse(item.requestNodeProvider),
    //     cronExpression = item.cronExpression.substring(5, item.cronExpression.length - 1);
    //     this.props.createEmailSchedulesRequest({
    //         id: item.id,
    //         status: item.status == 1 ? 0 : 1,
    //         schedulerName: item.schedulerName,
    //         toEmail: item.toEmail,
    //         ccEmail: item.ccEmail,
    //         hasAttachment: item.hasAttachment,
    //         cronExpression,
    //         dataExportJson
    //     });
    // }

    deleteSchedule = item => e => {
        this.props.handleApiChange("deleteEmailSchedulesRequest",{
            id: item.id,
            schedulerName: item.scheduler_name,
            "toEmail": item?.to_email,
            "ccEmail": item?.cc_email,
            "cronExpression": item?.cron_expression,
        }, getPermissionKey("common", "commonFunctionality", "view"));
    }

    selectToEmails = (field, items) => {
        let selectedItems = { ...this.state.toEmailsObj };
        if (items.length !== 0) {
            selectedItems[field.key] = items;
        }
        else if (items.length === 0 && selectedItems[field.key] !== undefined) {
            delete selectedItems[field.key];
        }
        this.setState({
            toEmailsObj: selectedItems,
            toEmailArray: [...items]
        });
    }

    selectCcEmails = (field, items) => {
        let selectedItems = { ...this.state.ccEmailsObj };
        if (items.length !== 0) {
            selectedItems[field.key] = items;
        }
        else if (items.length === 0 && selectedItems[field.key] !== undefined) {
            delete selectedItems[field.key];
        }
        this.setState({
            ccEmailsObj: selectedItems,
            ccEmail: [...items]
        });
    }

    setHeaders = () => {
        let clonDeepedHeadersMap = JSON.parse(JSON.stringify((this.props.mainHeadersData[this.state.headersType])))
        let headersMap = {...clonDeepedHeadersMap};
        if(this.state.level === "detailLevel") {
            this.props.detailHeadersData.forEach(item => {
                headersMap = {
                    ...headersMap,
                    ...item[this.state.headersType]
                };
            });
        }
        this.setState({
            headersMap,
            selectedItems: headersMap
        }, () => {});
    }
	closeEmailModal = () => {
		document.getElementById("reportModal")?.classList?.remove("from-right-in")
		document.getElementById("reportModal")?.classList?.add("from-right-out")
		setTimeout(()=>{
			this.props.close();
		}, 100)
	}

    handleChange = (type, data) => {
        switch (type) {
            case "chooseDay": {
                let updatedInputData = { ...this.state.inputData }
                if (updatedInputData?.["days"]?.includes(data)) {
                    updatedInputData["days"] = updatedInputData?.["days"].filter(item => item !== data)
                } else {
                    if (!updatedInputData?.["days"]) updatedInputData["days"] = [];
                    updatedInputData?.["days"].push(data);
                }
                console.log("Updated input data", updatedInputData);
                this.setState({ inputData: updatedInputData });
                break;
            }
            default: {
                this.setState(prevState => ({
                    inputData: {
                        ...prevState.inputData,
                        [type]: data
                    }
                }));
                break;
            }
        }
    }
    disabledDate = (current) => {
        return current && current < dayjs().startOf("day");
    };

    generateCron = () => {
        if (!this.state.inputData?.time) {
            return;
        }
        const minute = this.state.inputData?.time?.minute().toString().padStart(2, "0");
        const hour = this.state.inputData?.time.hour().toString().padStart(2, "0");

        let cronExpression = "";

        if (this.state.inputData?.scheduleType === "once") {
            if (!this.state.inputData?.oneTime) {
                return;
            }
            const day = this.state.inputData?.oneTime.date();
            const month = this.state.inputData?.oneTime.month() + 1; // Months are 0-based
            const year = this.state.inputData?.oneTime.year();
            cronExpression = `0 ${minute} ${hour} ${day} ${month} ? ${year}`;
        } else {
            if (this.state.inputData?.days?.length === 0) {
                return;
            }
            const days = this.state.inputData?.days?.join(",");
            cronExpression = `0 ${minute} ${hour} ? * ${days} *`;
        }
        return cronExpression;
    };

    parseCron(cronExpr) {
        const [ minute, hour, dayOfMonth, month, dayOfWeek] = cronExpr.trim().split(/\s+/);
        const now = new Date();
        const pad = num => String(num).padStart(2, '0');
    
        const formatTime = (h, m,) => {
            const date = new Date(now);
            date.setUTCHours(h, m, 0, 0);
            return date.toISOString();
        };
    
        const daysMap = {
            '1': 'MON',
            '2': 'TUE',
            '3': 'WED',
            '4': 'THU',
            '5': 'FRI',
            '6': 'SAT',
            'SUN': 'SUN',
            'MON': 'MON',
            'TUE': 'TUE',
            'WED': 'WED',
            'THU': 'THU',
            'FRI': 'FRI',
            'SAT': 'SAT',
        };
    
        // Parse day of week if it contains multiple or specific values
        let days = [];
        if (dayOfWeek && dayOfWeek !== '?' && dayOfWeek !== '*') {
            days = dayOfWeek.split(',').map(d => daysMap[d.toUpperCase()] || '').filter(Boolean);
        }
    
        const time = formatTime(hour, minute);
    
        if (days.length > 0) {
            return {
                scheduleType: "weekly",
                days,
                time : moment(time),
            };
        }
    
        // If no DOW but has a specific DOM (e.g., 4th of each month), consider it "once"
        const oneTime = formatTime(hour, minute);
        return {
            scheduleType: "once",
            days: [],
            oneTime : moment(oneTime),
            time : moment(time)
        };
    }

    render() {
        const daysObj = {
            MON: "Mon",
            TUE: "Tue",
            WED: "Wed",
            THU: "Thu",
            FRI: "Fri",
            SAT: "Sat"
        };
        return (
            <React.Fragment>
                <div className="modal">
                    <div className="backdrop" onClick={this.closeEmailModal}></div>
                    <div id='reportModal' className={`modal-content email-report-modal block !w-[480px] !absolute top-[0] right-[0] h-full !bg-white z-[99] !border-none !shadow-none !rounded-none from-right-in`}>
                        <div className="aerm-head flex items-center justify-between py-[15px] px-[25px] border-b border-[#b4c5d6]">
                            <div className="aermh-left">
                                {this.state.manageSchedule ? <LanguageTranslator tag="h3" className='text-sm font-bold text-[#12203c] m-[0]'>Manage Email Schedules</LanguageTranslator> : this.state.scheduler ? <LanguageTranslator tag="h3" className='text-sm font-bold text-[#12203c] m-[0]'>{this.state.editSchedule ? "Edit Scheduled Email" : "Schedule Email"}</LanguageTranslator> : <LanguageTranslator tag="h3" className='text-sm font-bold text-[#12203c] m-[0]'>Email Report</LanguageTranslator>}
                            </div>
                            <div className="aermh-right flex items-center">
                                <button type="button" className="aermh-manage text-xs font-semibold h-[32px] py-[5px] px-[15px] rounded-[4px] bg-white border border-[#dee6f4] mr-[15px] hover:bg-[#f5f5f5]" onClick={this.multipleToggle("manageSchedule")}>{this.state.manageSchedule ? <LanguageTranslator>Back</LanguageTranslator> : <LanguageTranslator>Manage Schedules</LanguageTranslator>}</button>
                                <span className="ermh-esc text-xs font-medium text-[#969fad] relative mr-[15px]">Esc</span>
                                <IconsPath.ClearSearch onClick={this.closeEmailModal} />
                            </div>
                        </div>
                        {!this.state.manageSchedule && !this.state.editSchedule &&
                        <div className="erm-scheduler flex justify-end py-[15px] px-[25px] border-b border-[#b4c5d6]">
                            <div className="generic-toggle">
                                <label className="gt-switch">
                                    <input type="checkbox" checked={this.state.scheduler} onChange={this.multipleToggle("scheduler")} />
                                    <span className="gt-slider"></span>
                                </label>
                            </div>
                            <LanguageTranslator tag="span" className="nph-text text-xs font-semibold text-[#778695] ml-[5px] pt-[2px]">Scheduler</LanguageTranslator>
                        </div>}
                        {this.state.manageSchedule ?
                        this.state.getDataSuccess ?
                        <div className={`erm-body ${this.state.manageSchedule ? !(this.state.emailSchedules.length > 0) ? 'h-full' : 'manageSchedule' : ''} aerm-body`}>
                            {this.state.emailSchedules.length > 0 ? this.state.emailSchedules.map((item, index) =>
                                <div key={item.id} style={{boxShadow: '0 0 16px 0 #cddaef'}} className={`scheduled-item rounded-lg mb-[20px] flex items-center ${index === 0 ? "m-top-20" : ""}`}>
                                    <div className="si-left py-2.5 px-[15px] border-r border-[#dee6f4] w-[72%]">
                                        <div className="sil-top">
                                            <h3 className='text-sm font-bold text-[#12203c] block m-[0] leading-[normal]'>{item.scheduler_name}</h3>
                                            <div className='mt-[12px] mb-3 text-fontBlack'>
                                                <p className='mb-1 text-xs text-fontGrey'>To</p>
                                                <div className='w-full flex items-center gap-2 flex-wrap'>
                                                {
                                                    this.state.showAll?.toMail ? item.to_email.split(',').map((key)=>
                                                        <p className='break-words mb-0 w-fit bg-[#E5E7EB] text-fontBlack font-medium text-[11px] break-all whitespace-normal px-1.5 py-0.5'>
                                                            {key}
                                                        </p>
                                                    ) :
                                                    <p className='break-words mb-0 w-fit bg-[#E5E7EB] text-fontBlack font-medium text-[11px] break-all whitespace-normal px-1.5 py-0.5'>
                                                        {item.to_email.split(',')[0]}
                                                    </p>
                                                }
                                                {
                                                    item.to_email.split(',').length > 1 && 
                                                        <GenericCustomButton
                                                            className='whitespace-nowrap text-xs font-medium text-fontBlack underline hover:text-primary'
                                                            label={this.state.showAll?.toMail ? 'View Less' : `+ ${item.to_email.split(',').length-1} more`}
                                                            onClick={()=> this.setState({
                                                                showAll : {...this.state.showAll, toMail : !this.state.showAll.toMail}
                                                            })}
                                                        />
                                                }
                                                </div>
                                            </div>
                                            {item.cc_email && <div className='mb-3 text-fontBlack'>
                                                <p className='mb-1 text-xs text-fontGrey'>CC</p>
                                                <div className='w-full flex items-center gap-2 flex-wrap'>
                                                    {
                                                    this.state.showAll?.ccMail ? item.cc_email.split(',').map((key)=>
                                                        <p className='break-words mb-0 w-fit bg-[#E5E7EB] text-fontBlack font-medium text-[11px] break-all whitespace-normal px-1.5 py-0.5'>
                                                            {key}
                                                        </p>
                                                    ) :
                                                    <p className='break-words mb-0 w-fit bg-[#E5E7EB] text-fontBlack font-medium text-[11px] break-all whitespace-normal px-1.5 py-0.5'>
                                                        {item.cc_email.split(',')[0]}
                                                    </p>
                                                }
                                                {
                                                    item.cc_email.split(',').length > 1 && 
                                                        <GenericCustomButton
                                                            className='whitespace-nowrap text-xs font-medium text-fontBlack underline hover:text-primary'
                                                            label={this.state.showAll?.ccMail ? 'View Less' : `+ ${item.cc_email.split(',').length-1} more`}
                                                            onClick={()=> this.setState({
                                                                showAll : {...this.state.showAll, ccMail : !this.state.showAll.ccMail}
                                                            })}
                                                        />
                                                }
                                                </div>
                                            </div>}
                                            {/* <span className="silt-mail">{item.to_email} <span className="siltm-count">{item.cc_email ? `+${item.cc_email.split(",").length} more` : ""}</span></span> */}
                                            {item.status == 1 ? <p className="silt-enabled relative text-xs font-medium text-[#2681ff] ml-[12px]">Enabled</p> : <p className="silt-disabled relative text-xs font-medium text-[#ff7703]">Disabled</p>}
                                        </div>
                                        <div className="sil-bottom mt-[37px]">
                                            {/* 
                                                // TODO
                                                <span className="silb-text">Daily</span>
                                            */}
                                            {this.isFilterApplied(item.request_node_provider) && <LanguageTranslator tag="span" className="silb-text text-[#6a7385] text-[11px] font-medium relative mr-[15px]">Filter applied</LanguageTranslator>}
                                            {item.has_attachment === "true" && <LanguageTranslator tag="span" className="text-[#6a7385] text-[11px] font-medium relative mr-[7px]">Send as attachment</LanguageTranslator>}
                                            <span className="silb-img text-[#6a7385] text-[11px] font-medium relative mr-[7px]">
                                                <svg xmlns="http://www.w3.org/2000/svg" id="attach_1_" width="18.526" height="18.526" viewBox="0 0 21.526 21.526">
                                                    <path id="Path_851" fill="#e0edff" d="M17.49 21.526H4.036A4.036 4.036 0 0 1 0 17.49V4.036A4.036 4.036 0 0 1 4.036 0H17.49a4.036 4.036 0 0 1 4.036 4.036V17.49a4.036 4.036 0 0 1-4.036 4.036z"/>
                                                    <path fill="#2681ff" id="Path_852" d="M18.314 12.675v.843a2.466 2.466 0 1 1-4.933 0V12.4h-.713a.115.115 0 0 1-.076-.032l-.637-.636a.777.777 0 0 0-.555-.232H9.233A1.232 1.232 0 0 0 8 12.733v5.606a1.233 1.233 0 0 0 1.233 1.234h8.3a1.233 1.233 0 0 0 1.234-1.233v-4.71a1.246 1.246 0 0 0-.453-.955z" class="cls-2" transform="translate(-2.618 -3.764)"/>
                                                    <path fill="#2681ff" id="Path_853" d="M18.9 14.433a1.572 1.572 0 0 1-1.569-1.569v-2.355a1.009 1.009 0 1 1 2.018 0v2.242a.336.336 0 1 1-.673 0v-2.242a.336.336 0 0 0-.673 0v2.354a.9.9 0 0 0 1.793 0V9.836a.336.336 0 1 1 .673 0v3.027a1.572 1.572 0 0 1-1.569 1.57z" class="cls-2" transform="translate(-5.673 -3.109)"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="si-right w-[28%] py-2.5 px-[15px]">
                                        {/* <button type="button" className="mb-3" onClick={this.disableSchedule(item)}>Disable</button> */}
                                        <button type="button" className="sir-edit block text-[11px] font-semibold text-[#21314b] bg-white h-[28px] border border-[#ccd8ed] rounded w-full hover:text-white hover:bg-primary hover:border-primary transition-all duration-500 my-[15px] mx-0" onClick={this.editSchedule(item)}>Edit</button>
                                        <button type="button" className={`block text-[11px] font-semibold text-[#21314b] bg-white h-[28px] border border-[#ccd8ed] rounded w-full hover:text-white hover:bg-primary hover:border-primary transition-all duration-500 ${this.props.generalStore.deleteEmailSchedulesData.isLoading && "opacity04"}`} onClick={ () =>{
                                            if(this.props.generalStore.deleteEmailSchedulesData.isLoading){
                                                return;
                                            }
                                            this.setState({
                                                selectedData : item,
                                                selectedModal : "deleteConfirmationModal",
                                            })
                                        }}><LanguageTranslator>Delete</LanguageTranslator></button>
                                    </div>
                                </div>
                            )
                            : <div className='h-full w-full flex items-center justify-center'><NoDataFound primaryText='No scheduled emails found!' /></div>
                        }
                        </div> :
                        this.state.getDataError ?
                        <div className="erm-body aerm-body">
                            <LanguageTranslator tag="label">Failed to fetch data!</LanguageTranslator>
                        </div> :
                        <div className="erm-body aerm-body">
                            <LanguageTranslator tag="label">Fetching data...</LanguageTranslator>
                        </div> :
                        <div className="erm-body aerm-body">
                            {this.state.scheduler &&
                            <div className="aermb-row">
                                <label><LanguageTranslator>Schedule Name</LanguageTranslator><span className="mandatory">*</span></label>
                                <input name="schedulerName" autoComplete="off" type="text" className={`aermb-input ${this.state.errors.schedulerName ? "errorBorder" : "onFocus"}`} value={this.state.schedulerName} onChange={this.handleInput} />
                                {this.state.errors.schedulerName && <LanguageTranslator tag="span" className="error-msg">Enter schedule name</LanguageTranslator>}
                            </div>}
                            <div className="aermb-row">
                                <label><LanguageTranslator>To</LanguageTranslator><span className="mandatory">*</span></label>
                                <GenericSearchModalNew
                                    isMandatory={false}
                                    multipleSelection={true}
                                    key={SITE_FILTER.key}
                                    field={SITE_FILTER}
                                    selectedItems={this.state.toEmailsObj}
                                    selectItems={this.selectToEmails}
                                    {...this.props}
                                />
                                {this.state.errors.toEmail && <span className="error-msg">Enter valid email address</span>}
                            </div>
                            <div className="aermb-row">
                                <LanguageTranslator tag="label">CC</LanguageTranslator>
                                <GenericSearchModalNew
                                    isMandatory={false}
                                    multipleSelection={true}
                                    key={SITE_FILTER.key}
                                    field={SITE_FILTER}
                                    selectedItems={this.state.ccEmailsObj}
                                    selectItems={this.selectCcEmails}
                                    {...this.props}
                                />
                            </div>
                            {["VIEW_INDENTS", "VIEW_ORDERS"].includes(this.props.headerLevelModule) &&
                            <div className="aermb-row">
                                <label>Date Range</label>
                                {this.state.scheduler ?
                                <span className="date-range">
                                    <label className="radio-label">
                                        <input type="radio" name="dateRange" value={"SM_DATE_TODAY_VALUE"} checked={this.state.dateRange === "SM_DATE_TODAY_VALUE"} onChange={this.handleInput} />
                                        <span className="radio-check"></span>
                                        <span className="radio-text"><LanguageTranslator>Today</LanguageTranslator></span>
                                    </label>
                                    <label className="radio-label">
                                        <input type="radio" name="dateRange" value={"SM_DATE_YESTERDAY_VALUE"} checked={this.state.dateRange === "SM_DATE_YESTERDAY_VALUE"} onChange={this.handleInput} />
                                        <span className="radio-check"></span>
                                        <span className="radio-text"><LanguageTranslator>Yesterday</LanguageTranslator></span>
                                    </label>
                                    <label className="radio-label">
                                        <input type="radio" name="dateRange" value={"SM_DATE_LAST7DAYS_VALUE"} checked={this.state.dateRange === "SM_DATE_LAST7DAYS_VALUE"} onChange={this.handleInput} />
                                        <span className="radio-check"></span>
                                        <span className="radio-text"><LanguageTranslator>Last 7 Days</LanguageTranslator></span>
                                    </label>
                                    <label className="radio-label">
                                        <input type="radio" name="dateRange" value={"SM_DATE_LASTWEEK_VALUE"} checked={this.state.dateRange === "SM_DATE_LASTWEEK_VALUE"} onChange={this.handleInput} />
                                        <span className="radio-check"></span>
                                        <span className="radio-text"><LanguageTranslator>Last Week</LanguageTranslator></span>
                                    </label>
                                    <label className="radio-label">
                                        <input type="radio" name="dateRange" value={"SM_DATE_THISMONTH_VALUE"} checked={this.state.dateRange === "SM_DATE_THISMONTH_VALUE"} onChange={this.handleInput} />
                                        <span className="radio-check"></span>
                                        <span className="radio-text"><LanguageTranslator>Current Month</LanguageTranslator></span>
                                    </label>
                                    <label className="radio-label">
                                        <input type="radio" name="dateRange" value={"SM_DATE_LASTMONTH_VALUE"} checked={this.state.dateRange === "SM_DATE_LASTMONTH_VALUE"} onChange={this.handleInput} />
                                        <span className="radio-check"></span>
                                        <span className="radio-text"><LanguageTranslator>Last Month</LanguageTranslator></span>
                                    </label>
                                </span> :
                                <RangePicker
                                    locale = {this.updatedLocale}
                                    className={this.state.errors.fromDate || this.state.errors.toDate ? "errorBorder" : ""}
                                    picker="date"
                                    onChange={this.handleDateInput}
                                    value={this.state.fromDate && this.state.toDate ? [dayjs(this.state.fromDate), dayjs(this.state.toDate)] : [null, null]}
                                    format={"YYYY-MM-DD"}
                                />}
                                {(this.state.errors.fromDate || this.state.errors.toDate) && <span className="error-msg">Select valid date range</span>}
                            </div>}
                            {this.state.scheduler &&
                                <React.Fragment>
                                    <div className="ist-update">
                                        <LanguageTranslator tag="label" className='utc-time'>Start time should be in UTC timezone which is minus (-) 5:30 HRS from IST (Indian Standard Timezone).</LanguageTranslator>
                                    </div>
                                    <div className="aermb-row">
                                        <Radio.Group
                                            onChange={(e) => this.handleChange("scheduleType", e.target.value)}
                                            value={this.state.inputData?.scheduleType || "once"}
                                        >
                                            <Radio className='mr-5 ant-radio-label' value="once">Once</Radio>
                                            <Radio className='ant-radio-label' value="weekly">Repeat</Radio>
                                        </Radio.Group>
                                    </div>
                                    <div className="aermb-row">
                                        {this.state.inputData?.scheduleType !== "weekly" ?
                                            <>
                                                <GenericInput
                                                    key="oneTime"
                                                    mandatory={this.state.inputData?.scheduleType !== "weekly"}
                                                    label="Date"
                                                    type="date"
                                                    value={this.state.inputData?.oneTime || ""}
                                                    disabledDate={(date) => this.disabledDate(date)}
                                                    onChange={(data) => this.handleChange("oneTime", data)}
                                                />
                                            </> :
                                            <div className='days-list'>
                                                {Object.keys(daysObj).map((key) =>
                                                    <GenericCustomButton
                                                        type={this.state.inputData?.["days"]?.includes(key) ? 'active' : 'default'}
                                                        className={`ajms-day-btn`}
                                                        label={<LanguageTranslator>{daysObj[key]}</LanguageTranslator>}
                                                        onClick={() => this.handleChange("chooseDay", key)}
                                                    />
                                                )}
                                            </div>}
                                    </div>
                                    <div className="aermb-row">
                                        <GenericInput
                                            key="time"
                                            mandatory={true}
                                            label="Time"
                                            type="time"
                                            value={this.state.inputData?.time || ""}
                                            onChange={(data) => this.handleChange("time", data)}
                                            format="h:mm A"
                                        />
                                    </div>
                                </React.Fragment>}
                            {!this.state.editSchedule && <div className="ermb-dashdata">
                                <LanguageTranslator tag="h3">Attachments</LanguageTranslator>
                                <div className="ermbdd-inner">
                                    <div className="ermbddi-checkbox">
                                        <label className="checkBoxLabel0">
                                            <input type="checkBox" name="hasAttachment" checked={this.state.hasAttachment} onChange={this.handleInput} /><LanguageTranslator>Send as attachment</LanguageTranslator>
                                            <span className="checkmark1"></span>
                                        </label>
                                    </div>
                                    <div className="gen-pi-formate">
                                        <ul className="gpf-radio-list">
                                            <li>
                                                <label className="gen-radio-btn">
                                                    <input type="radio" name="isAllData" value="false" checked={this.state.level === "headerLevel"} onChange={(e) => {this.handleInput(e, "headerLevel")}} />
                                                    <span className="checkmark"></span>
                                                    <LanguageTranslator>Header level</LanguageTranslator>
                                                </label>
                                            </li>
                                            {this.props.detailHeadersData && <li>
                                                <label className="gen-radio-btn">
                                                    <input type="radio" name="isAllData" value="true" checked={this.state.level === "detailLevel"} onChange={(e) => {this.handleInput(e, "detailLevel")}} />
                                                    <span className="checkmark"></span>
                                                    <LanguageTranslator>Detail Level</LanguageTranslator>
                                                </label>
                                            </li>}
                                        </ul>
                                    </div>
                                </div>
                            </div>}
                            {!this.state.editSchedule && <div className="ermb-dashdata">
                                <div className="ermbdd-inner">
                                    <div className="ermbddi-checkbox">
                                        <label className="checkBoxLabel0">
                                            <input name="filterCondition" type="checkBox" checked={this.state.filterCondition} onChange={this.handleInput} />
                                            <LanguageTranslator tag="h3" style={{lineHeight: "initial"}}>Send with applied filters and search</LanguageTranslator>
                                            <span className="checkmark1"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>}
                        </div>}
                        {!this.state.manageSchedule &&
                        <div className="erm-footer w-full !flex items-center gap-3 py-2.5 px-[25px] absolute bottom-[10px] bg-white">
                            {/* {this.props.generalStore.emailReportData.isLoading || this.props.generalStore.createEmailSchedulesData.isLoading ?
                            <button type="button" className="ermf-send btn-loader" disabled><div class="spinner-border text-light btn-loader-inner"></div></button> :
                            <button type="button" className="ermf-send" onClick={this.onSubmit}>{this.state.scheduler ? <LanguageTranslator>Schedule Email</LanguageTranslator> : <LanguageTranslator>Send Now</LanguageTranslator>}</button>}
                            <button type="button" className="ermf-clear" onClick={this.clearData}><LanguageTranslator>Clear</LanguageTranslator></button> */}
                            <GenericCustomButton
                                type='primary'
                                size='large'
                                loading={this.props.generalStore.emailReportData.isLoading || this.props.generalStore.createEmailSchedulesData.isLoading}
                                label={this.state.scheduler ? 'Schedule Email' : 'Send Now'}
                                onClick={this.onSubmit}
                                className='w-3/4'
                            />
                             <GenericCustomButton
                                type='default'
                                size='large'
                                label={this.state.editSchedule ? "Discard" : "Clear"}
                                onClick={this.clearData}
                                className="w-1/4"
                             />
                        </div>}
                    </div>
                </div>
             
                {/* Render the pop up modal for the delete confirmation modal */}
                {
                    this.state.selectedModal === "deleteConfirmationModal" && <div className='!h-screen !w-screen !fixed !top-[0] !left-[0] z-[9999] flex items-center justify-center'>
                        <div className='backdrop !h-screen !w-screen !fixed !top-[0] !left-[0]'></div>
                        <div className='relative max-w-[500px] h-auto bg-white from-bot-in'>
                            <GenericDeleteModal
                                parentModalOuterMostClassName = {'flex items-center justify-center'}
                                postitionProps = {{ position: 'relative' }}
                                dimensions = {{ minWidth: "350px", minHeight: '150px', height: "fit-content", maxWidth: '450px', maxHeight: '600px' }}
                                label = {"Deleting Email Scheduler"}
                                subLabel = {"If this scheduler contains attachments, they will also be deleted."}
                                deleteLoading = {this.props.generalStore.deleteEmailSchedulesData?.isLoading ?? false}
                                finalSubmit = {() => {
                                    this.deleteSchedule(this.state?.selectedData)?.()
                                }}
                                closeModal = {() => {
                                    this.setState({
                                        selectedModal:false,
                                        selectedData: null,
                                    })
                                }}
                            />
                        </div>
                    </div>
                }

            </React.Fragment>
        )
    }
}

export default EmailScheduler